export function Loading() {
  return (
    <div className="flex flex-1 items-center justify-center">
      <span className="loading loading-spinner loading-lg text-primary" />
    </div>
  );
}
